// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579694328656
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/views/SearchCompany/SearchCompany.scss
// module id = ./src/views/SearchCompany/SearchCompany.scss
// module chunks = 0